import { requestFetchXCSRFToken, setDeviceVariant } from 'actions/appActions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from 'types';
import App from '../App';

const mapStateToProps = (state: RootState) => {
  return {
    isInitializedXCSRFToken: state.app.isInitializedXCSRFToken,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onRequestFetchXCSRFToken: () => {
      dispatch(requestFetchXCSRFToken());
    },
    setDeviceVariant: (userDevice: string) => {
      dispatch(setDeviceVariant(userDevice));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
